import glamorous from "glamorous"
import style from "utils/style"

const Tagline = glamorous.div({
  fontSize: "1.4rem",
  fontStyle: "italic",
  letterSpacing: -1,
  lineHeight: 1.4,
  paddingBottom: 10,
  color: style.colors.darkBrown,
})

export default Tagline



// WEBPACK FOOTER //
// ./src/elements/Tagline.js